var m = require('mithril');
var layout = require('../layout/layout');
var aggregate = require('./aggregates');
var aggregateEditor = require('./aggregateEditor');
var pointDetail = require('./pointDetail');
var audit = require('./audit');
var errors = require('./errors');
var reports = require('../reports/reportFolders');
var vistest = require('./vistest');

module.exports = {
  '/point/:pointId/:tabId': {
    view: function() {
      return m(layout, m(pointDetail));
    },
  },
  '/point/:pointId': {
    view: function() {
      return m(layout, m(pointDetail));
    },
  },
  '/aggregate/:key': {
    view: function() {
      return m(layout, m(aggregateEditor));
    },
  },
  '/aggregates': {
    view: function() {
      return m(layout, m(aggregate));
    },
  },
  '/audit': {
    view: function() {
      return m(layout, m(audit));
    },
  },
  '/reports': {
    view: function() {
      return m(layout, m(reports));
    },
  },
  '/errors': {
    view: function() {
      return m(layout, m(errors));
    },
  },
};
